import {graphql, useStaticQuery} from "gatsby";

const useDocumentLinks = () => {
    const data = useStaticQuery(graphql`
        query DocumentsQuery {
            strapiSettings {
                cookieDocument {
                    localFile {
                        publicURL
                    }
                }
                formAgreementDocument {
                    localFile {
                        publicURL
                    }
                }
            }
        }
    `);
    const {strapiSettings} = data;

    return {
        cookieDocument: strapiSettings?.cookieDocument?.localFile?.publicURL ?? "",
        formAgreementDocument: strapiSettings?.formAgreementDocument?.localFile?.publicURL ?? "",
    };
};

export default useDocumentLinks;
